export default "__VITE_ASSET__BvcaZznQ__"